import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import API from '../utils/API';

// fetchUsers
export const fetchUsers = createAsyncThunk('users/fetchUsers', async () => {
  const response = await API.getAllUsers();
  return response.data;
});

// addUser
export const addUser = createAsyncThunk(
  'users/addUser',
  async (userData, thunkAPI) => {
    console.log('Starting addUser thunk:', userData)
    try {
      const response = await API.addUser(userData);
      console.log('ADD USER RESPONSE:', response)
      return response.data;
    } catch (error) {
      console.log('ADD USER ERROR:', error);
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);

// editUser
export const editUser = createAsyncThunk(
  'users/editUser',
  async (userInfo, thunkAPI) => {
    try {
      console.log(userInfo);
      const response = await API.editUser(userInfo);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);

// deleteUser
export const deleteUser = createAsyncThunk(
  'users/deleteUser',
  async ({ id, roleId }, thunkAPI) => {
    try {
      // console.log(id, roleId);
      await API.deleteUserRole(id, roleId);
      await API.deleteUser(id);
      return id;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);

// addAlertPlusUser
export const addAlertPlusUser = createAsyncThunk(
  'users/addAlertsPlusUser',
  async (userData, thunkAPI) => {
    try {
      const response = await API.addAlertPlusUser(userData);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);

const usersSlice = createSlice({
  name: 'users',
  initialState: {
    users: [],
    loading: false,
    error: null
  },
  reducers: {
    usersRequested: (state) => {
      state.loading = true;
      state.error = null;
    },
    usersReceived: (state, action) => {
      state.users = action.payload;
      state.loading = false;
    },
    usersRequestFailed: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    userAdded: (state, action) => {
      state.users.push(action.payload);
    },
    userUpdated: (state, action) => {
      const { id, firstName, lastName, email, phone, site, cms, role  } = action.payload;
      const existingUser = state.users.find(user => user.id === id);
      if (existingUser) {
        existingUser.firstName = firstName;
        existingUser.lastName = lastName;
        existingUser.email = email;
        existingUser.phone = phone;
        existingUser.site = site;
        existingUser.cms = cms;
        existingUser.role = role;
      }
    },
    userDeleted: (state, action) => {
      state.users = state.users.filter(user => user.id !== action.payload);
    },
  },
  extraReducers: (builder) => {
    // Fetch users
    builder.addCase(fetchUsers.pending, (state) => {
      state.usersLoading = true;
      state.usersError = null;
    })
    builder.addCase(fetchUsers.fulfilled, (state, action) => {
      state.usersLoading = false;
      state.usersError = null;
      state.users = action.payload;
    })
    builder.addCase(fetchUsers.rejected, (state, action) => {
      state.usersLoading = false;
      state.usersError = action.payload;
    })
    // Add reducers for additional action types here, and handle loading state as needed
    // Add user
    builder.addCase(addUser.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    builder.addCase(addUser.fulfilled, (state, action) => {
      state.users.push(action.payload);
      state.loading = false;
    })
    builder.addCase(addUser.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    })
    // Edit user
    builder.addCase(editUser.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    builder.addCase(editUser.fulfilled, (state, action) => {
      const { id, firstName, lastName, email, phone } = action.payload || {};
      const existingUser = state.users.find(user => user.id === id);
      if (existingUser) {
        existingUser.firstName = firstName;
        existingUser.lastName = lastName;
        existingUser.email = email;
        existingUser.phone = phone;
      }
      state.loading = false;
    })
    builder.addCase(editUser.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    })
    // Delete user
    builder.addCase(deleteUser.fulfilled, (state, action) => {
      state.users = state.users.filter(user => user.id !== action.payload);
      state.loading = false;
    })
    builder.addCase(deleteUser.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    })
    // Add Alert Plus User
    builder.addCase(addAlertPlusUser.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    builder.addCase(addAlertPlusUser.fulfilled, (state, action) => {
      state.users.push(action.payload);
      state.loading = false;
    })
    builder.addCase(addAlertPlusUser.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });
  },
});

export const {
  usersRequested,
  usersReceived,
  usersRequestFailed,
  userAdded,
  userUpdated,
  userDeleted,
} = usersSlice.actions;

export default usersSlice.reducer;